import "./RegionStatusBar.scss";
import moment from "moment";
export default {
  name: "RegionStatusBar",
  props: {
    regions: {
      type: Array,
      default: null
    },
    filter: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    slopeCount() {
      const slopeCount = this.regions.map(region => {
        if (region?.pois.length) {
          const foundPoi = region.pois.filter(
            poi => poi.category === "6049bf33b42c5b001117298b"
          );
          return foundPoi.length;
        } else return 0;
      });
      return slopeCount.reduce((partialSum, a) => partialSum + a, 0);
    },
    regionsBarInfo() {
      const infoArray = [];
      this.regions
        .filter(r => r)
        .forEach(region => {
          if (
            !this.filter.regions ||
            this.filter.regions.length === 0 ||
            this.filter.regions.includes(region._id)
          ) {
            if (region.mainPoi?.category === "60b49f7b9d71c30012efbe57") {
              infoArray.push(this.slopesInfo(region));
            } else {
              infoArray.push(this.trailsInfo(region));
            }
          }
        });
      return infoArray;
    }
  },
  methods: {
    isOpenGivenDay(poi, day) {
      if (
        poi?.state?.state === "open" ||
        poi?.state?.state === "partiallyOpen"
      ) {
        return true;
      }
      if (poi?.state?.state !== "openingHours") {
        return false;
      }
      const allTimes = [];
      poi?.calculatedOpeningHours?.forEach(t => {
        allTimes.push(t[0]);
      });
      return allTimes.some(t => {
        const tday = moment(t * 1000).format("MM DD YYYY");
        return tday === day;
      });
    },
    liftStatus(region, dayToCheck) {
      const lifts = region.pois?.filter(
        p => p.categoryGroup === "6049fb2adcd565001178b35a"
      );
      const openLifts = lifts?.filter(p => this.isOpenGivenDay(p, dayToCheck));
      return {
        sum: lifts?.length,
        open: openLifts?.length || 0,
        openLifts
      };
    },
    allOpenPois(region, dayToCheck) {
      return region.pois?.filter(p => this.isOpenGivenDay(p, dayToCheck));
    },
    anyValleyRun(pois) {
      return pois?.some(p => p?.state?.hasValleyRun);
    },
    slopesKm(region, dayToCheck) {
      // slopes
      const slopes = region.pois.filter(
        p =>
          p.categoryGroup === "6049bf1ab42c5b0011172985" &&
          this.isOpenGivenDay(p, dayToCheck)
      );
      let slopesMeter = 0;
      slopes.forEach(p => {
        slopesMeter += p.state?.length || p.state?.valleyLength;
      });
      let km = slopesMeter / 1000;
      return km?.toFixed(1).replace(".", ",");
    },
    trailsInfo(region) {
      const trails = region?.pois?.filter(p => p.categoryURIPart === "loipe");
      const skating = trails.filter(
        p =>
          p.state?.trackType === "skating" ||
          p.state?.trackType === "classicAndSkating"
      );
      const classic = trails.filter(
        p =>
          p.state?.trackType === "classic" ||
          p.state?.trackType === "classicAndSkating"
      );
      const skatingOpen = skating.filter(p =>
        this.isOpenGivenDay(p, moment().format("MM DD YYYY"))
      );
      const classicOpen = classic.filter(p =>
        this.isOpenGivenDay(p, moment().format("MM DD YYYY"))
      );
      let skatingKm = 0;
      skatingOpen.forEach(s => {
        skatingKm += (s.state?.length || s.state?.valleyLength) / 1000;
      });
      skatingKm = skatingKm.toFixed(1);
      let classicKm = 0;
      classicOpen.forEach(s => {
        classicKm += (s.state?.length || s.state?.valleyLength) / 1000;
      });
      classicKm = classicKm.toFixed(1);

      let anyTrackOpen = skatingOpen?.length > 0 || classicOpen?.length > 0;

      let floodlight = "";
      if (anyTrackOpen) {
        let floodlightArr = [];
        trails.forEach(p => {
          if (p.state?.floodlightAt?.join("")?.length) {
            p.state?.floodlightAt.forEach(f => {
              floodlightArr.push(f);
            });
          }
        });
        floodlightArr = [...new Set(floodlightArr)]; //array unique
        if (floodlightArr.length > 0) {
          floodlightArr = floodlightArr.map(day =>
            day
              .replace("mo", "1Mo")
              .replace("tu", "2Di")
              .replace("we", "3Mi")
              .replace("th", "4Do")
              .replace("fr", "5Fr")
              .replace("sa", "6Sa")
              .replace("su", "7So")
          );
          floodlightArr.sort();

          //build connection days week-overview fe. Mo-Fr,So
          let connectionDays = [];
          let firstDayOfSequence = "";
          let lastNum = 1;
          floodlightArr.forEach(d => {
            let dayNum = parseInt(d);
            if (dayNum - 1 === lastNum) {
              connectionDays[connectionDays.length - 1] = (
                firstDayOfSequence +
                "-" +
                d
              ).replace(/\d/g, "");
            } else {
              connectionDays.push(d.replace(/\d/g, ""));
              firstDayOfSequence = d;
            }
            lastNum = dayNum;
          });
          connectionDays = connectionDays.filter(d => !!d); //remove empty days
          floodlight = connectionDays.join(",").replace("Mo-So", "täglich");
        }
      }

      return {
        type: "trails",
        mainPoiCity: region?.mainPoi?.address?.city || "-",
        skating: skating?.length,
        classic: classic?.length,
        skatingOpen: skatingOpen?.length,
        classicOpen: classicOpen?.length,
        skatingKm: skatingKm.replace(".", ","),
        classicKm: classicKm.replace(".", ","),
        floodlight,
        homepage: region?.mainPoi?.address?.website || ""
      };
    },
    slopesInfo(region) {
      let info = {};
      info.title = region.title;
      info.type = "ski";
      info.open = this.isOpenGivenDay(
        region.mainPoi,
        moment().format("MM DD YYYY")
      );
      info.minSnow = region.mainPoi?.state?.valleySnowDepth;
      info.maxSnow = region.mainPoi?.state?.mountainSnowDepth;
      info.lifts = this.liftStatus(region, moment().format("MM DD YYYY"));
      info.valleyRun =
        info.open &&
        this.anyValleyRun(
          this.allOpenPois(region, moment().format("MM DD YYYY"))
        );
      info.firstAscent = region.mainPoi?.state?.firstAscent || "-:-";
      info.slopesKm = this.slopesKm(region, moment().format("MM DD YYYY"));
      return info;
    }
  }
};
